module.exports = __webpack_public_path__ + "img/authenticator_TOTP.3a44bf97.png";